<script setup lang="ts">
defineProps<{
  saveNotice?: string;
  canSave: boolean;
}>();

const emit = defineEmits<{
  close: [];
  save: [];
}>();
</script>

<template>
  <div class="sidebar-actions">
    <NAlert v-if="saveNotice" type="info" :show-icon="false" class="save-notice">
      {{ saveNotice }}
    </NAlert>
    <NButton block size="large" @click="emit('close')">Close</NButton>
    <NButton block type="primary" size="large" :disabled="!canSave" @click="emit('save')">
      Save
    </NButton>
  </div>
</template>

<style scoped>
.sidebar-actions {
  flex-shrink: 0;
  padding: 16px 12px;
  border-top: 1px solid var(--n-border-color);
  background-color: var(--n-color);
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.save-notice {
  font-size: 12px;
  line-height: 1.5;
  white-space: pre-line;
}
</style>
